import { getGsap } from "./GsapGlobals";

export class ClipPathRevealController {
    static init(): void {
        const gsap = getGsap();
        if (!gsap) return;

        document.querySelectorAll<HTMLElement>(".clip-down-up").forEach((img) => {
            gsap.fromTo(
                img,
                { clipPath: "inset(0 0 100% 0)" },
                {
                    clipPath: "inset(0 0 0% 0)",
                    duration: 1.2,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: img,
                        start: "top 80%",
                    },
                },
            );
        });

        document.querySelectorAll<HTMLElement>(".scale-img img").forEach((img) => {
            gsap.fromTo(
                img,
                { scale: 1.3 },
                {
                    scale: 1.1,
                    duration: 1.2,
                    scrollTrigger: {
                        trigger: img,
                        start: "top 80%",
                    },
                },
            );
        });
    }
}
